import IdExtFaconnier from './IdExtFaconnier'

export default IdExtFaconnier
